import React from "react";
import DataGrid from "./DataGrid/DataGrid.tsx";

interface KFNOperationsDataGridProps {
  data: any[];
  isLoading: boolean;
}

const KFNOperationsDataGrid: React.FC<KFNOperationsDataGridProps> = ({
  data,
  isLoading,
}) => {
  const columns = [
    {
      name: "PolNum",
      header: "№ Полица",
      type: "string",
    },
    {
      name: "InsComp",
      header: "ЗК",
      type: "string",
    },
    {
      name: "InsType",
      header: "Вид Полица",
      type: "string",
    },
    {
      name: "Sum_Pol",
      header: "Застр. Премия",
      type: "number",
    },
    {
      name: "GF_Sum",
      header: "ГФ Сума",
      type: "number",
    },
  ];

  return (
    <DataGrid
      columns={columns}
      dataSource={data}
      isLoading={isLoading}
      gridTitle="Оперативни справки за КФН"
      idProperty="PolNum"
      csvFilename="kfn_operations_report.csv"
      icon="fa-kit fa-regular-file-circle-question"
    />
  );
};

export default KFNOperationsDataGrid;
